import React, {Component} from 'react';
import './DeviceSettingsTab.css';
import CommandAPIs from '../../../../APIs/CommandAPIs';
import _ from 'lodash';

export const intervalMap = {
    '30': {
        label: '30 Sec',
        desc: '6 hrs standby from 100%',
    },
    '60': {
        label: '1 Min',
        desc: '12 hrs standby',
    },
    '120': {
        label: '2 Min',
        desc: '24 hrs standby',
    },
    '1800': {
        label: '30 Min',
        desc: '4 days standby',
    },
    '3600': {
        label: '1 Hrs',
        desc: '7 days standby',
    },
    '7200': {
        label: '2 Hrs',
        desc: '10 days standby',
    },
    '14400': {
        label: '4 Hrs',
        desc: '20 days standby',
    },
    '28800': {
        label: '8 Hrs',
        desc: '30 days standby',
    },
    '64800': {
        label: '18 Hrs',
        desc: '45 days standby',
    },
    '86400': {
        label: '24 Hrs',
        desc: '60 days standby',
    },
}

class DeviceSettingsTab extends Component {
    render() {
        let config = [];
        let vehicle = window.selectedVehicle;
        if(vehicle && vehicle.deviceTypesList.indexOf('concox_at4') > -1) {
            config.push(
                {
                    key: 'gps',
                    title: 'GPS',
                    type: 'GPS',
                    forms: [
                        {
                            key: 'interval',
                            title: 'Beacon Interval',
                            type: 'select',
                            options: [
                                {
                                    title: 'Live tracking mode',
                                    items: _.pick(intervalMap, ['30', '60', '120', '1800', '3600']),
                                },
                                {
                                    title: 'Battery saving mode',
                                    items: _.pick(intervalMap, ['7200', '14400', '28800', '64800', '86400']),
                                },
                            ],
                            onClick: (e, vehicleid, beacon_frequency) => {
                                if(!beacon_frequency) return;
                                let parent = e.target.parentNode;
                                let span = parent.querySelector('span');
                                span.innerText = '';
                                let lds = parent.querySelector('.lds-ring');
                                lds.style.display = null;
                                CommandAPIs.setAssetTrackerBeaconFreq({vehicleid, beacon_frequency}).then(rsp => {
                                    span.innerText = 'Settings will be delivered once the device connects to network';
                                    lds.style.display = 'none';
                                })
                            }
                        },
                    ],
                }
            );
        }
        return (
            <div>
                {config.length == 0 && <div className="ds-box-empty">No devices to configure</div>}
                {config.map(c => {
                    return (
                        <div className="ds-box" key={c.key}>
                            <div className="dsbh">{c.title}</div>
                            <div className="dsbb">
                                {c.forms.map(f => {
                                    let input = null;
                                    if(f.type == 'select') {
                                        let selectListener = e => {
                                            let style = e.target.parentNode.querySelector('.d-d').style;
                                            if(style.display) style.display = null;
                                            else style.display = 'block';
                                        }
                                        let mapOpts = (o, i) => {
                                            let onClick = e => {
                                                f.value = i;
                                                f.ref.style.display = null;
                                                f.ref.parentNode.querySelector('.d-s').innerHTML = o.label + '<span>' + o.desc + '</span>';
                                            }
                                            return <div className="dd-v" onClick={onClick}>{o.label}<span>{o.desc}</span></div>
                                        }
                                        input = (
                                            <div className="dsdd-c">
                                                <div className="d-s" onClick={selectListener}>{'Select interval'}</div>
                                                <div className="d-d" ref={ref => f.ref = ref}>
                                                    {f.options.map(o => {
                                                        if(o.items) {
                                                            return [<div className="dd-h">{o.title}</div>].concat(_.map(o.items, mapOpts));
                                                        } return mapOpts(o);
                                                    })}
                                                </div>
                                            </div>
                                        )
                                    } else {
                                        let inputProps = {type:f.type};
                                        if(f.type == 'number') Object.assign(inputProps, {max:f.max,min:f.min});
                                        input = <input {...inputProps} ref={ref => f.ref = ref} />
                                    }
                                    return (
                                        <div className="dsbbs" key={f.key}>
                                            <div className="dsbbr">
                                                <div className="dsbbl">{f.title}</div>
                                                <div className="dsbbt">{input}</div>
                                            </div>
                                            <div className="dsbbg">
                                                <span></span>
                                                <button onClick={e => f.onClick(e, vehicle.vehicleid, parseInt(f.value))}><div className="lds-ring" style={{display:'none'}}><div></div></div>Save</button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default DeviceSettingsTab;